import { defineComponent as L, ref as g, provide as y, h as l, Fragment as x, Teleport as N, reactive as P } from "vue";
import { NotificationContainer as S } from "./ghl-ui.es1070.js";
import { NotificationEnvironment as C } from "./ghl-ui.es1071.js";
import { notificationProviderInjectionKey as I } from "./ghl-ui.es1072.js";
import K from "./ghl-ui.es1073.js";
import H from "./ghl-ui.es887.js";
import b from "./ghl-ui.es888.js";
import { omit as w } from "./ghl-ui.es1074.js";
import { createInjectionKey as T } from "./ghl-ui.es913.js";
import { createId as _ } from "./ghl-ui.es778.js";
import B from "./ghl-ui.es1075.js";
const E = T("n-notification-api"), z = Object.assign(Object.assign({}, b.props), { containerStyle: [String, Object], to: [String, Object], scrollable: {
  type: Boolean,
  default: !0
}, max: Number, placement: {
  type: String,
  default: "top-right"
}, keepAliveOnHover: Boolean }), X = L({
  name: "NotificationProvider",
  props: z,
  setup(r) {
    const { mergedClsPrefixRef: a } = H(r), e = g([]), o = {}, t = /* @__PURE__ */ new Set();
    function c(i) {
      const n = _(), f = () => {
        t.add(n), o[n] && o[n].hide();
      }, u = P(Object.assign(Object.assign({}, i), {
        key: n,
        destroy: f,
        hide: f,
        deactivate: f
      })), { max: p } = r;
      if (p && e.value.length - t.size >= p) {
        let v = !1, h = 0;
        for (const m of e.value) {
          if (!t.has(m.key)) {
            o[m.key] && (m.destroy(), v = !0);
            break;
          }
          h++;
        }
        v || e.value.splice(h, 1);
      }
      return e.value.push(u), u;
    }
    const s = ["info", "success", "warning", "error"].map((i) => (n) => c(Object.assign(Object.assign({}, n), { type: i })));
    function O(i) {
      t.delete(i), e.value.splice(e.value.findIndex((n) => n.key === i), 1);
    }
    const j = b("Notification", "-notification", K, B, r, a), d = {
      create: c,
      info: s[0],
      success: s[1],
      warning: s[2],
      error: s[3],
      open: A,
      destroyAll: R
    }, k = g(0);
    y(E, d), y(I, {
      props: r,
      mergedClsPrefixRef: a,
      mergedThemeRef: j,
      wipTransitionCountRef: k
    });
    function A(i) {
      return c(i);
    }
    function R() {
      Object.values(e.value).forEach((i) => {
        i.hide();
      });
    }
    return Object.assign({
      mergedClsPrefix: a,
      notificationList: e,
      notificationRefs: o,
      handleAfterLeave: O
    }, d);
  },
  render() {
    var r, a, e;
    const { placement: o } = this;
    return l(
      x,
      null,
      (a = (r = this.$slots).default) === null || a === void 0 ? void 0 : a.call(r),
      this.notificationList.length ? l(
        N,
        { to: (e = this.to) !== null && e !== void 0 ? e : "body" },
        l(S, { style: this.containerStyle, scrollable: this.scrollable && o !== "top" && o !== "bottom", placement: o }, {
          default: () => this.notificationList.map((t) => l(C, Object.assign({ ref: (c) => {
            const s = t.key;
            c === null ? delete this.notificationRefs[s] : this.notificationRefs[s] = c;
          } }, w(t, [
            "destroy",
            "hide",
            "deactivate"
          ]), { internalKey: t.key, onInternalAfterLeave: this.handleAfterLeave, keepAliveOnHover: t.keepAliveOnHover === void 0 ? this.keepAliveOnHover : t.keepAliveOnHover })))
        })
      ) : null
    );
  }
});
export {
  X as default,
  E as notificationApiInjectionKey,
  z as notificationProviderProps
};
